import { parseFuelCalibration, applyFuelCalibration } from '@/lib/calibrationUtils';

const NONE = { value: null, unit: null, percent: null, calibrated: false, source: null };

/**
 * The one fuel-level rule for the Live Map card, the vehicle list column and friends.
 * A fuel profile's calibrated litres win; otherwise the legacy device calibration path.
 * Pure: pass the overview row (or undefined), the device and the latest position.
 */
export function resolveFuelLevel({ overviewRow, device, position } = {}) {
  if (overviewRow?.profileId && typeof overviewRow.litres === 'number' && Number.isFinite(overviewRow.litres)) {
    return { value: overviewRow.litres, unit: 'L', percent: overviewRow.percent ?? null, calibrated: true, source: 'profile' };
  }
  const rawFuel = position?.attributes?.fuel ?? null;
  if (rawFuel == null) return { ...NONE };
  const calibration = parseFuelCalibration(device?.attributes?.fuelCalibration);
  const value = applyFuelCalibration(rawFuel, calibration);
  if (value == null) return { ...NONE };
  const calibrated = calibration != null;
  const unit = calibrated
    ? (calibration.unit === 'gallons' ? 'gal' : calibration.unit === 'liters' ? 'L' : '%')
    : '%';
  return { value, unit, percent: null, calibrated, source: 'legacy' };
}

/**
 * Replay's fuel series: positions carry no overview row, so the profile's level source/key/tank
 * decide how to read each position. Without a usable profile it is the legacy attributes.fuel.
 */
export function replayFuelSeries(overviewRow) {
  const num = (v) => (typeof v === 'number' && Number.isFinite(v) ? v : null);
  if (overviewRow?.profileId && overviewRow.levelKey) {
    const { levelSource, levelKey, tankLitres } = overviewRow;
    if (levelSource === 'can_percent' && num(tankLitres)) {
      return { unit: 'L', read: (p) => { const v = num(p?.attributes?.[levelKey]); return v == null ? null : (v * tankLitres) / 100; } };
    }
    if (levelSource === 'can_litres') {
      return { unit: 'L', read: (p) => num(p?.attributes?.[levelKey]) };
    }
  }
  return { unit: 'L', read: (p) => p?.attributes?.fuel ?? null };
}
